export const getSwiperStyles = (
	isSmallScreen: boolean,
	slots: Array<any>,
	swiperContainerGradient: string | null,
	swiperButtonChevrons: { chevronLeft: string; chevronRight: string }
) => {
	const { chevronLeft, chevronRight } = swiperButtonChevrons;

	return {
		width: '100%',
		'.swiper': {
			maskImage: isSmallScreen && slots.length > 3 && swiperContainerGradient,
			'.swiper-button-disabled': {
				display: 'none',
			},
			'.swiper-button-prev': {
				'::after': {
					content: 'none',
				},
				backgroundImage: `linear-gradient(270deg, rgba(0,0,0,0) 0%, rgba(255,255,255,1) 50%), url('data:image/svg+xml;utf8,${chevronLeft}')`,
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'inherit',
				backgroundBlendMode: 'color-burn',
				left: '0',
				top: '0',
				position: 'absolute',
				width: '30px',
				height: '52px',
				zIndex: 10,
			},
			'.swiper-button-next': {
				'::after': {
					content: 'none',
				},
				backgroundImage: `linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(255,255,255,1) 50%), url('data:image/svg+xml;utf8,${chevronRight}')`,
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'inherit',
				backgroundBlendMode: 'color-burn',
				right: '0',
				top: '0',
				position: 'absolute',
				width: '30px',
				height: '52px',
				zIndex: 10,
			},
			'.swiper-scrollbar': {
				display: 'none',
			},
		},
	};
};

export const noSlotsAlertStyles = {
	alertStyles: {
		'.MuiAlert-icon': {
			alignItems: 'center',
		},
	},
	richTextStyles: {
		ul: {
			'padding-inline-start': '1.5rem',
		},
		'.MuiTypography-root': {
			fontFamily: 'inherit',
			fontSize: 'inherit',
			lineHeight: 'inherit',
			fontWeight: 'inherit',
		},
	},
};
